import { Box } from '@hopskipdrive/react-components';
import styled from 'styled-components';

import { colorTokens } from '../../../../../shared/components/variables';

export const Heading = styled(Box)`
  display: flex;
  flex-direction: column;

  gap: 20px;
`;

export const InnerCard = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 12px;
  gap: 20px;
  width: 100%;

  border-radius: 12px;
  border: 1.38px solid ${colorTokens.border.main};
  background: #f7fafc;
`;
